import { useContext, useEffect, useState } from 'react'
import './TopUnes.css'
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog'
import Loading from '../../../../components/Loading/Loading'
import { Doc_Counter, GetDocs } from '../../../../firebase/utils'
import { useNavigate } from 'react-router-dom'
import { DashboardContext } from '../../../../Hooks/DashboardContext'
import TopUne from './TopUne/TopUne'
import Counter from '../../../../components/Counter/Counter'
import Pill from '../../../../components/Pill/Pill'
import Toggle from '../../../../components/Toggle/Toggle'

const TopUnes = () => {
    const [TopUnes,setTopUnes]=useState(null)

    const {searchValue,setMaxBannerNumber}=useContext(DashboardContext)
  
    const [filteredItems,setfilteredItems]=useState(null)
    const [totalTopUnes,setTotalTopUnes]=useState(0)
    const navigate = useNavigate();

   
   
    useEffect(() => {
      
      document.querySelector('#Loading').showModal()
      GetDocs("TopUnes").then((result)=>setTopUnes(result))
      Doc_Counter('TopUnes',setTotalTopUnes)

     
    }, [/*TopUnes*/])
  
    useEffect(
      ()=>{

        if (TopUnes===null) return
        document.querySelector('#Loading').close()
  
        setfilteredItems(TopUnes.filter(
          (topUne)=>
            topUne.Nom.toLowerCase().includes(searchValue.toLowerCase())
        ))

        console.log(totalTopUnes)
  
      },[searchValue,TopUnes]
    )
    
   
  
  
    return (
      <div className='Products_container'>
       
      
        <div>
          <h1>
            Liste des Produits à la une 
          </h1>
          <div  style={{width:'100%',padding:'2rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'4rem'}}>
            <Counter maxValue={5} minValue={0} setMaxNumber={setMaxBannerNumber}/>
            <Pill bgcolor={'#333'} bordercolor={'transparent'} classe={'disabled'} color={'#777'} onclick={e=>{return null}} text={"mettre à jour la limite"} key={''}/>
           <div style={{display:'flex',alignItems:'center',gap:'0.5rem'}}>
            <span>Désactiver la visibilité sur le Homepage : </span>
             <Toggle HandleToggle={e=>{return null}}/>
           </div>
      
          </div>
        </div>
        
        <div className='Products FadeIn' >
          
        {filteredItems!==null&&filteredItems.length<=0&&searchValue!==''?'Aucun produit ne correspond a la recherche':
  
          filteredItems===null? <Loading/> :  filteredItems.map((topUne,id)=>{ return (<TopUne key={id} TopUneDetails={topUne}/>)})
  
        }
  
          <ConfirmDialog/>
  
          
        </div>
      </div>
    )
}

export default TopUnes